import RoutesApp from './routes'

export default function App() {
  return <RoutesApp />
}